import { Component, OnInit, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { CookiePolicyComponent } from './cookie-policy/cookie-policy.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-cookie-consent',
  templateUrl: './cookie-consent.component.html',
  styleUrls: ['./cookie-consent.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class CookieConsentComponent implements OnInit {
  isActive: boolean;
  @Output() accept: EventEmitter<undefined> = new EventEmitter();

  constructor(private dialog: MatDialog) {}

  ngOnInit() {
    setTimeout(() => (this.isActive = true), 3000);
  }

  showPolicy(e: Event) {
    e.preventDefault();
    this.hide();
    const dialogRef = this.dialog.open(CookiePolicyComponent, {
      width: '90vw',
      maxWidth: '1024px',
      height: '90vh',
      data: {},
    });
    dialogRef.afterClosed().subscribe(() => {
      this.isActive = true;
    });
  }

  onAccept(e: Event) {
    e.preventDefault();
    setTimeout(() => this.accept.emit(), 1000);
    this.hide();
  }

  hide() {
    this.isActive = false;
  }
}
